export default {
    password: 'required|min:8|regex:^([0-9A-Za-zА-яа-я!@#$%^&*\-\.]+)$',
    authPassword: 'required',
    login: 'required|min:5|regex:^([0-9A-Za-z_\.@-]+)$',
    authLogin: 'required',
}
